import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { map, sortBy } from 'lodash';
import resources from 'app/store/resources';
import Widget from 'app/components/Widget/Widget.jsx';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground.js';
import { Title } from 'app/components/Texts/Title/Title.jsx';
import { ModulableTree } from 'app/components/ModulableTree/ModulableTree.jsx';
import { permission } from 'app/containers/Permissions/index.js';
import { MUIButton } from 'app/components/Form';
import { Toggle } from 'app/components/Form/indexTS';
import { Tooltip } from 'app/components/Tooltip/Tooltip.jsx';
import { openModal, confirmDelete } from 'app/components/Modal';
import { ModalEditStatus } from 'app/pages/Admin/StatusEditing/ModalEditStatus';
import classes from 'app/pages/Admin/StatusEditing/StatusEditing.module.scss';
import { progressionStatusSelector } from 'app/store/selectors/progressionStatus';
const StatusEditing = () => {
    const [enableUpdateRank, setEnableUpdateRank] = useState(false);
    const progressionStatus = useSelector(progressionStatusSelector);
    useEffect(() => {
        resources.progressionStatus.fetchAll();
    }, []);
    function statusEdition(progressionStatus) {
        return (e) => openModal(_jsx(ModalEditStatus, { progressionStatus: progressionStatus }));
    }
    function deleteStatus(statusId) {
        return (e) => confirmDelete({
            render: 'Are you sure you want to delete this status?',
            onValidate: () => resources.progressionStatus.delete(statusId),
        });
    }
    function onDrop(content, data, index) {
        const { index: dragIndex } = content;
        if (Number.isNaN(dragIndex))
            return Promise.resolve();
        if (Number(dragIndex) >= Number(index) && index !== 0) {
            index += 1;
        }
        const itemToMove = data[dragIndex];
        data.splice(dragIndex, 1);
        data.splice(index > 0 ? index : 0, 0, itemToMove);
        return resources.progressionStatus.update(data.map(({ id }, index) => ({ id, order: index })), {
            batch: true,
            updateBeforeRequest: true,
        });
    }
    function getItems() {
        const orderedProgressionStatus = sortBy(progressionStatus, ['order']);
        return map(orderedProgressionStatus, (ps, index) => {
            return {
                key: ps.name,
                dragContent: enableUpdateRank && {
                    data: ps,
                    index,
                },
                actions: enableUpdateRank &&
                    permission([]) && [
                    {
                        key: 'delete',
                        onClick: () => deleteStatus(ps.id),
                        tooltip: 'Remove status',
                    },
                ],
                drop: ({ content }) => onDrop(content, orderedProgressionStatus, index),
                label: (_jsxs("div", { className: "flex row", style: { marginLeft: -10 }, children: [_jsx("div", { style: { width: 30, height: 38, borderRight: 'solid 1px #E8E8E8', marginRight: 10 }, className: "flex center alignCenter", children: index }), _jsx("div", { className: "flex alignCenter marginRight10 relative", style: !enableUpdateRank ? { pointerEvents: 'all', zIndex: 10 } : undefined, children: _jsx(Tooltip, { title: "Edit status", children: _jsx("div", { className: classes.status, style: {
                                        backgroundColor: ps.color,
                                        color: getColorFromBackground(ps.color),
                                    }, onClick: statusEdition(ps), children: ps.name }) }) })] })),
            };
        });
    }
    return (_jsx("div", { className: "flex", children: _jsx(Widget, { style: { padding: 10, width: 'auto' }, children: _jsx(ModulableTree, { title: _jsx(Title, { size: 3, className: "marginRight50", children: "Status editing" }), treeProps: {
                    hideOrigin: true,
                    noExpand: true,
                    noLevel: true,
                    noDragIcon: true,
                }, Header: _jsxs("div", { className: "flex row marginBottom10", children: [_jsx(MUIButton, { onClick: statusEdition(), icon: "fas-plus", children: "Add a status" }), _jsx("div", { className: "marginLeft10", children: _jsx(Toggle, { value: enableUpdateRank, option1: {
                                    label: 'Edit',
                                    value: true,
                                }, option2: {
                                    label: 'Locked',
                                    value: false,
                                    disabled: true,
                                }, onChange: setEnableUpdateRank }) })] }), draggableContentDir: false, items: getItems() }) }) }));
};
export default StatusEditing;
